import {
  BaseRequestActionCreator,
  BaseRequestSuccessActionCreator,
  BaseRequestFailureActionCreator,
} from "types";
import { Data } from "./types";

export const GET_STARTED_REFRESH_REQUEST = "GET_STARTED_REFRESH_REQUEST";
export const GET_STARTED_REFRESH_REQUEST_SUCCESS = "GET_STARTED_REFRESH_REQUEST_SUCCESS";
export const GET_STARTED_REFRESH_REQUEST_FAILURE = "GET_STARTED_REFRESH_REQUEST_FAILURE";

export const request: BaseRequestActionCreator = (resolve, reject) => ({
  type: GET_STARTED_REFRESH_REQUEST,
  resolve,
  reject,
});

export const requestSuccess: BaseRequestSuccessActionCreator<Data> = (data) => ({
  type: GET_STARTED_REFRESH_REQUEST_SUCCESS,
  data,
});

export const requestFailure: BaseRequestFailureActionCreator = (error) => ({
  type: GET_STARTED_REFRESH_REQUEST_FAILURE,
  error,
});
